const AutoFill = ($timeout) => {
  'ngInject'
  const require = 'ngModel'
  const link = (scope, element, attrs, ngModel) => {
    let origVal = element.val()
    $timeout(() => {
      let newVal = element.val()
      if (ngModel.$pristine && origVal !== newVal) {
        ngModel.$setViewValue(newVal)
      }
    }, 500)
  }
  return { require, link }
}

export default AutoFill



// WEBPACK FOOTER //
// ./src/app/common/validators/auto-fill.js